import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import SongOptions from './song-options';

@inject('songsStore', 'artistStore')
@observer
class SongRow extends Component {
	constructor(props) {
		super(props);


		this.state = { 
			isHovered: false,
		}
	}

	@autobind
	parseTime(time) {
        if (_.isNaN(time)) {
            return ("0:00");
        }
        var mins = Math.floor((time / 60)).toFixed(0);
        var secs = Math.floor((time % 60)).toFixed(0);
        return (mins + ":" + (secs < 10 ? "0" : "") + secs);

	}

	render () {
		const {
			songID,
			song,
			active,
			songsStore,
			artistStore
		} = this.props;

		if (artistStore.isLoading || songsStore.isLoading) {

			return (<h4>Loading...</h4>);
		}


		const classList = [
			'grid-x',
			'align-justify',
			'align-middle',
			'song-row'
		];

		if (songID === songsStore.activeSongRowID) {

			classList.push('active');
		}

		return (
			<div className={ classList.join(' ') } onMouseEnter={() => this.setState({isHovered:true})} onMouseLeave={() => this.setState({isHovered:false})}>
				<div className="cell shrink margin-right-1">
					<div 
						className="song-row-counter" 
						data-full-preview-position={ song.fullPreviewPosition }
						data-ta="play-button-container"
					>
						<span
							className={`icon far fa-play-circle ${this.state.isHovered ? 'fa-pause' : ''}`}
							onClick={ this.props.playAction }
						data-ta="play-button"
					></span>
					</div>
				</div>

				<div className="cell small-4">
					<div
						className="inline"
						onBlur={ this.onEditableBlur }
						ref={ (node) => this.songTitleRef = node }
					>
						{ song.title }
					</div>
				</div>

				<div className="cell small-5">
				</div>

				<div className="cell auto text-center">
					{song.duration}
				</div>

				<div className="cell small-1">
					{ this.renderUserOpts() }
				</div>
			</div>
		);
	}

	@autobind
	renderUserOpts () {
		const { songID, songsStore, optionsTheme, onBlur } = this.props;
		const song = songsStore.getSongByID(songID);
		return (
			<Fragment>
				<SongOptions
					songID={ songID }
					song={ song }
					optionsTheme={ 'light' }
					onBlur={ onBlur }
					isHovered={this.state.isHovered}
				/>
			</Fragment>
		)
	}

	@autobind
	onPlayClick () {
		const { songID, songsStore } = this.props;
		songsStore.setCurrentSong(songID);
	}
	
	@autobind
	onCheckboxChange ({ target: { checked } }) {
		this.props.song.explicit = checked;
	}

	@autobind
	onEditableBlur ({ target: { innerHTML: title } }) {
		this.props.song.title = title;
	}
}

export default SongRow;
